import { createAction } from 'redux-actions';

export const fetchRoles = createAction('FETCH_ROLES');
export const fetchRolesSuccess = createAction('FETCH_ROLES_SUCCESS');
